// Copyright (c) 2024. UpCircle Technology AG.
// All rights reserved. Redistribution in source and/or binary forms,
// with or without modification, is not permitted.

// This file includes firebase resources and API, 
// exported to enable authentication and use across all other scripts. 

// firebase resources
import { initializeApp } from 'firebase/app';
import { getAuth, connectAuthEmulator } from 'firebase/auth';
import { getStorage, connectStorageEmulator } from 'firebase/storage';
import { getFirestore, connectFirestoreEmulator } from 'firebase/firestore';
import { getFunctions, connectFunctionsEmulator } from 'firebase/functions';
import { getAnalytics, logEvent } from 'firebase/analytics';

// // // PROD DATABASE CONFIG (upcircleai-dashboard)
const firebaseConfig = {
    apiKey: "AIzaSyC9K39Yu1OqDsaDdC2q8tPqsTTT9-ksa9M",
    authDomain: "upcircleai-dashboard.firebaseapp.com",
    projectId: "upcircleai-dashboard",
    storageBucket: "upcircleai-dashboard.appspot.com",
    messagingSenderId: "951071303444",
    appId: "1:951071303444:web:0f9f5863f17b2797484401",
    measurementId: "G-QZQ868R21T"
};

// // DEV DATABASE CONFIG (upcircleai-dashboard-dev-9135f)
// export const firebaseConfig = {
//     apiKey: "AIzaSyB7A0wVwAnq887GY7F4yRsW5FDoR7QFUsM",
//     authDomain: "upcircleai-dashboard-dev-9135f.firebaseapp.com",
//     projectId: "upcircleai-dashboard-dev-9135f",
//     storageBucket: "upcircleai-dashboard-dev-9135f.firebasestorage.app",
//     messagingSenderId: "298239964806",
//     appId: "1:298239964806:web:4f1443695d7ba269040307"
//   };

// // DEV GLOBAL DATABASE CONFIG (upcircleai-dashboard-devglobal)
// const firebaseConfig = {
//     apiKey: "AIzaSyAQ1L9hPW1tlVzcvrbaEen0hrhdfihcLiQ",
//     authDomain: "upcircleai-dashboard-devglobal.firebaseapp.com",
//     projectId: "upcircleai-dashboard-devglobal",
//     storageBucket: "upcircleai-dashboard-devglobal.firebasestorage.app",
//     messagingSenderId: "726311385374",
//     appId: "1:726311385374:web:f3c0e1debf5ddc2e8bf10f"
//   };

// initialize firebase and resources
const firebaseApp = initializeApp(firebaseConfig);
const auth = getAuth(firebaseApp);
const storage = getStorage(firebaseApp);
const firestore = getFirestore(firebaseApp);
const functions = getFunctions(firebaseApp);
const analytics = getAnalytics(firebaseApp);

// connect to firebase emulator if in development mode
const USE_EMULATOR = false;
if (USE_EMULATOR) {
    connectFirestoreEmulator(firestore, 'localhost', 8080);
    connectFunctionsEmulator(functions, 'localhost', 5001);
    //connectStorageEmulator(storage, 'localhost', 9199);
    //connectAuthEmulator(auth, 'http://localhost:9099');
}

export { firebaseApp, auth, storage, firestore, functions, analytics }